<template>
  <div
    class="modal-content detail-content bg-white rounded-none overflow-hidden"
    style="height: calc(100dvh - 80px)"
  >
    <div class="modal-employee-detail">
      <div class="employee-detail-highlight">
        <div class="highlight-profile">
          <div
            class="profile-image"
            :class="{ 'profile-image-defult': image.get }"
          >
            <img
              :src="image?.get ?? DefaultProfile"
              :alt="employee.name ?? ''"
            />
          </div>

          <div class="profile-name">
            <p>{{ employee.name }}</p>
            <p>{{ employee.ein }}</p>
            <p>{{ employee.email }}</p>
            <pill
              :text="employee.is_active === 1 ? 'Active' : 'Not Active'"
              :icon="
                employee.is_active === 1 ? mdiCheckDecagram : mdiAlertDecagram
              "
              type="info"
            />
          </div>
        </div>

        <div class="highlight-table">
          <table>
            <tr>
              <td>{{ $t("employee.section") }}</td>
              <td>:</td>
              <td>{{ employee.section }}</td>
            </tr>

            <tr>
              <td>{{ $t("workunit.title") }}</td>
              <td>:</td>
              <td>{{ employee.satker_name }}</td>
            </tr>

            <tr>
              <td>{{ $t("students.cardNumber") }}</td>
              <td>:</td>
              <td>{{ employee.id_card_no }}</td>
            </tr>

            <tr>
              <td>{{ $t("Status") }}</td>
              <td>:</td>
              <td>{{ employee.state }}</td>
            </tr>

            <tr v-if="employee.state == 'Permanent'">
              <td>{{ $t("Decree No.") }}</td>
              <td>:</td>
              <td>{{ employee.decree_no }}</td>
            </tr>

            <tr v-if="employee.state == 'Permanent'">
              <td>{{ $t("Decree Date") }}</td>
              <td>:</td>
              <td>{{ formatDate(employee.decree_date) }}</td>
            </tr>

            <tr>
              <td colspan="1" style="padding-top: 20px">
                <pill
                  @click="editDataEmployee()"
                  :text="'Edit Data'"
                  :icon="mdiAccountEditOutline"
                  type="success"
                  style="cursor: pointer"
                />
              </td>
              <td colspan="2" style="padding-top: 20px">
                <pill
                  @click="showEmployeeHistory()"
                  :text="$t('employee.update_history')"
                  :icon="mdiAccountEditOutline"
                  type="info"
                  style="cursor: pointer"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="student-tab">
        <div class="employe-tabs-container">
          <div class="employe-tabs-outer">
            <div class="employe-tabs-content">
              <div
                v-for="(tab, index) in sortedTabs"
                :key="index"
                @click="activeTab = tab.index"
                class="tab-content"
                :class="activeTab === tab.index ? 'tab-content-active' : ''"
              >
                <p>{{ tab.name }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="employee-general-container">
          <div v-if="activeTab === 0" class="table-container">
            <div class="group-container">
              <p class="title-group">Personal</p>

              <div class="group-content">
                <table>
                  <tr>
                    <td>{{ $t("employee.placeOfBirth") }}</td>
                    <td>:</td>
                    <td>{{ employee.place_of_birth }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.dateOfBirth") }}</td>
                    <td>:</td>
                    <td>{{ employee.date_of_birth }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.married") }}</td>
                    <td>:</td>
                    <td>{{ employee.married }}</td>
                  </tr>

                  <tr>
                    <td>Number of Chlidren</td>
                    <td>:</td>
                    <td>{{ employee.number_children }}</td>
                  </tr>
                </table>

                <table>
                  <tr>
                    <td>{{ $t("employee.religion") }}</td>
                    <td>:</td>
                    <td>{{ employee.religion }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.ethnic") }}</td>
                    <td>:</td>
                    <td>{{ employee.ethnic }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.gender") }}</td>
                    <td>:</td>
                    <td>{{ employee.gender }}</td>
                  </tr>

                  <tr>
                    <td>Address</td>
                    <td>:</td>
                    <td>{{ employee.address }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="group-container">
              <p class="title-group">Information</p>

              <div class="group-content">
                <table>
                  <tr>
                    <td>{{ $t("employee.idCard") }}</td>
                    <td>:</td>
                    <td>{{ employee.id_card }}</td>
                  </tr>

                  <tr>
                    <td>Status</td>
                    <td>:</td>
                    <td>{{ employee.state }}</td>
                  </tr>

                  <tr v-if="employee.state == 'Permanent'">
                    <td>Decree No.</td>
                    <td>:</td>
                    <td>{{ employee.decree_no }}</td>
                  </tr>

                  <tr v-if="employee.state == 'Permanent'">
                    <td>Decree Date</td>
                    <td>:</td>
                    <td>{{ formatDate(employee.decree_date) }}</td>
                  </tr>

                  <tr>
                    <td>Retirement Age</td>
                    <td>:</td>
                    <!-- <td>{{ employee.retirement_age }}</td> -->
                    <td>{{ employee.work_unit_retirement_age }}</td>
                  </tr>

                  <tr>
                    <td>Retirement Date</td>
                    <td>:</td>
                    <td>{{ employee.retirement_date }}</td>
                  </tr>

                  <tr>
                    <td>Retirement Status</td>
                    <td>:</td>
                    <td>
                      <span
                        :style="{
                          color: employee.retirement_status ? 'green' : 'red',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ employee.retirement_status ? "✓" : "✗" }}
                      </span>
                    </td>
                  </tr>
                </table>

                <table>
                  <tr>
                    <td>Start Working</td>
                    <td>:</td>
                    <td>{{ employee.start_working }}</td>
                  </tr>

                  <tr>
                    <td>Active Employee</td>
                    <td>:</td>
                    <td>
                      {{ employee.is_active == 1 ? "Active" : "Not Active" }}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.taxIdNumber") }}</td>
                    <td>:</td>
                    <td>{{ employee.tin }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("vacode.bankName") }}</td>
                    <td>:</td>
                    <td>{{ employee.bank }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.bankAccount") }}</td>
                    <td>:</td>
                    <td>{{ employee.bank_account }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="group-container">
              <p class="title-group">Contact</p>

              <div class="group-content">
                <table>
                  <tr>
                    <td>{{ $t("employee.mobileNum") }}</td>
                    <td>:</td>
                    <td>{{ employee.mobile_no }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("employee.phoneNum") }}</td>
                    <td>:</td>
                    <td>{{ employee.telp }}</td>
                  </tr>
                </table>

                <table>
                  <tr>
                    <td>{{ $t("employee.email") }}</td>
                    <td>:</td>
                    <td>{{ employee.email }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("schoolidentity.website") }}</td>
                    <td>:</td>
                    <td>{{ employee.website }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="group-container">
              <p class="title-group">Others</p>

              <div class="group-content">
                <table>
                  <tr>
                    <td>{{ $t("class.createdAt") }}</td>
                    <td>:</td>
                    <td>{{ employee.created_at }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("class.createdBy") }}</td>
                    <td>:</td>
                    <td>{{ employee.created_by }}</td>
                  </tr>
                </table>

                <table>
                  <tr>
                    <td>{{ $t("class.updatedAt") }}</td>
                    <td>:</td>
                    <td>{{ employee.updated_at }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("class.updatedBy") }}</td>
                    <td>:</td>
                    <td>{{ employee.updated_by }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- <table>
              <tbody>
                <tr>
                  <td>{{ $t("employee.idCard") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.id_card }}
                  </td>
                  <td>{{ $t("candidate.familycardId") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.familycard_id }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.passport") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.passport }}
                  </td>
                  <td>{{ $t("employee.taxIdNumber") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.tin }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.placeOfBirth") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.place_of_birth }}
                  </td>
                  <td>{{ $t("employee.dateOfBirth") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.date_of_birth }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("vacode.bankName") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.bank }}
                  </td>
                  <td>{{ $t("employee.bankAccount") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.bank_account }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.healthcare") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.healthcare }}
                  </td>
                  <td>{{ $t("employee.socialSecurity") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.social_security }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.religion") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.religion }}
                  </td>
                  <td>{{ $t("employee.ethnic") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.ethnic }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.married") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.married }}
                  </td>
                  <td>{{ $t("employee.gender") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.gender }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.phoneNum") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.telp }}
                  </td>
                  <td>{{ $t("employee.mobileNum") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.mobile_no }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.email") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.email }}
                  </td>
                  <td>{{ $t("schoolidentity.website") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.website }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.facebook") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.facebook }}
                  </td>
                  <td>{{ $t("employee.twitter") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.twitter }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.startWorking") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.start_working }}
                  </td>
                  <td>{{ $t("candidate.blood") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.bloodtype }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("employee.address") }}</td>
                  <td colspan="3" class="text-base font-base text-gray-500">
                    {{ employee.address }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("class.createdAt") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.created_at }}
                  </td>
                  <td>{{ $t("class.createdBy") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.created_by }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("class.updatedAt") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.updated_at }}
                  </td>
                  <td>{{ $t("class.updatedBy") }}</td>
                  <td class="text-base font-base text-gray-500">
                    {{ employee.updated_by }}
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>

          <div v-if="activeTab === 1" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Position')"
              />

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('Position')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Department</th>
                    <th>{{ $t("position.title") }}</th>
                    <th>Date</th>
                    <th>Decree</th>
                    <th>{{ $t("vaccines.description") }}</th>
                    <th>Main Function</th>
                    <th>Active</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(position, index) in positionData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ position.department_name }}</td>
                    <td>{{ position.position_name }}</td>
                    <td>{{ position.tmt }}</td>
                    <td>{{ position.sk }}</td>
                    <td>{{ position.description }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="grey"
                          style="background-color: grey; color: white"
                          :icon="mdiCheckCircle"
                          small
                          :disabled="!checkUser"
                          @click="updateMainData(true, position)"
                          v-if="!position.is_main || position.is_main == false"
                        />
                        <jb-button
                          color="success"
                          :icon="mdiCheckCircle"
                          small
                          @click="updateMainData(false, position)"
                          v-else
                        />
                      </div>
                    </td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="grey"
                          style="background-color: grey; color: white"
                          :icon="mdiCheckCircle"
                          small
                          :disabled="!checkUser"
                          @click="updateActiveData(true, position)"
                          v-if="
                            !position.is_active || position.is_active == false
                          "
                        />
                        <jb-button
                          color="success"
                          :icon="mdiCheckCircle"
                          small
                          @click="updateActiveData(false, position)"
                          v-else
                        />
                      </div>
                    </td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="deleteFile(position, 'employeeposition')"
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="editData('Position', position)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Position', position)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 2" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('employeecareerpath')"
              />
              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('CareerPath')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Employee</th>
                    <th>Career Path</th>
                    <th>Start Date</th>
                    <th>Decree No</th>
                    <th>Decree Expire Date</th>
                    <th>Decree file</th>
                    <th>Is Closed</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(
                      employeecareerpath, index
                    ) in employeeCareerPathData"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ employeecareerpath.employee_name }}</td>
                    <td>{{ employeecareerpath.career_path_name }}</td>
                    <td>{{ employeecareerpath.start_date }}</td>
                    <td>{{ employeecareerpath.decree_no }}</td>
                    <td>{{ employeecareerpath.decree_expire_date }}</td>
                    <td>{{ employeecareerpath.file_name }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          v-if="
                            !employeecareerpath.is_closed ||
                            employeecareerpath.is_closed == false
                          "
                          color="grey"
                          style="background-color: grey; color: white"
                          :icon="mdiCheckCircle"
                          small
                          @click="updateCarClosed(true, employeecareerpath)"
                        />
                        <jb-button
                          v-else
                          color="success"
                          :icon="mdiCheckCircle"
                          small
                          @click="updateCarClosed(false, employeecareerpath)"
                        />
                      </div>
                    </td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="warning"
                          :icon="mdiDownload"
                          small
                          @click="
                            download(
                              'employeecareerpath',
                              employeecareerpath.filename
                            )
                          "
                        />
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="
                            deleteFile(
                              employeecareerpath,
                              'employee-career-path'
                            )
                          "
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="
                            editData('employeecareerpath', employeecareerpath)
                          "
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="
                            detailData('employeecareerpath', employeecareerpath)
                          "
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 3" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Branch')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Branch</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(branch, index) in branchData.value" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ branch.branch_name }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="deleteFile(branch, 'employeebranch')"
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="editData('Branch', branch)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Branch', branch)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- <div v-if="activeTab === 4" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                v-if="checkUser"
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addData('Retirement')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>{{ $t("employee.retirement") }}</th>
                    <th>{{ $t("vaccines.description") }}</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(retire, index) in retireData.value" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ retire.date }}</td>
                    <td>{{ retire.remarks }}</td>
                    <td>
                      <jb-buttons >
                        <jb-button
                          v-if="checkUser"
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          @click="deleteFile(retire, 'retirement')"
                        />
                        <jb-button
                          v-if="checkUser"
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          @click="editData('Retirement', retire)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Retirement', retire)"
                        />
                      </jb-buttons>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->

          <!-- <div v-if="activeTab===3">
              <jb-button class="mb-2" label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addData('salary')" />
              <table class="border-dashed w-full col-span-2">
                  <thead>
                      <tr>
                          <td>No</td>
                          <td>{{ $t('academicyear.date') }}</td>
                          <td>{{ $t('employee.salary') }}</td>
                          <td>SK</td>
                          <td>{{ $t('vaccines.description') }}</td>
                          <td>{{ $t('class.isActive') }}</td>
                          <td></td>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(salary, index) in salaryData.value" :key="index">
                          <td>{{ index+1 }}</td>
                          <td>{{ salary.date }}</td>
                          <td>{{ salary.salary }}</td>
                          <td>{{ salary.sk }}</td>
                          <td>{{ salary.description }}</td>
                          <td></td>
                      </tr>
                  </tbody>
              </table>
          </div> -->

          <div v-if="activeTab === 5" class="table-container">
            <div class="employee-buttons-action">
              <!-- <jb-button v-if="checkUser" class="mb-2" label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addData('employeetraining')" /> -->

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('employeetraining')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Name</th>
                    <th>Organizer</th>
                    <th>Venue</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>External Training?</th>
                    <th>Certificate No</th>
                    <th>Certificate Exp Date</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(
                      employeetraining, index
                    ) in employeeTrainingData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ employeetraining.name }}</td>
                    <td>{{ employeetraining.organizer }}</td>
                    <td>{{ employeetraining.venue }}</td>
                    <td>{{ employeetraining.start_date }}</td>
                    <td>{{ employeetraining.end_date }}</td>
                    <td>{{ employeetraining.is_external ? "Yes" : "No" }}</td>
                    <td>{{ employeetraining.certificate_no }}</td>
                    <td>{{ employeetraining.certificate_exp_date }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="
                            deleteFile(employeetraining, '/employee-training')
                          "
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="
                            editData('employeetraining', employeetraining)
                          "
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="
                            detailData('employeetraining', employeetraining)
                          "
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 6" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Contract')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Decree No.</th>
                    <th>Decree Date</th>
                    <th>Period End Date</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(contract, index) in contractData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ contract.decree_no }}</td>
                    <td>{{ contract.decree_date }}</td>
                    <td>{{ contract.period_end_date }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="deleteFile(contract, 'employeecontract')"
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="editData('Contract', contract)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Contract', contract)"
                        />
                        <jb-button
                          color="purple"
                          :icon="mdiTextBoxSearch"
                          small
                          @click="wordFile('Contract', contract.id)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 7" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Education')"
              />

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('Education')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Degree</th>
                    <th>Institution</th>
                    <th>Year of Graduation</th>
                    <th>Diploma No.</th>
                    <th>Description</th>
                    <th>Diploma File.</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(education, index) in educationData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ education.degree }}</td>
                    <td>{{ education.school }}</td>
                    <td>{{ education.graduate }}</td>
                    <td>{{ education.sk }}</td>
                    <td>{{ education.remarks }}</td>
                    <td>{{ education.file }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="warning"
                          :icon="mdiDownload"
                          small
                          @click="download('education', education.file)"
                        />
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="deleteFile(education, 'employeeschool')"
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="editData('Education', education)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Education', education)"
                        />
                      </div>
                    </td>
                    <!-- <td v-html="journal.comment"></td> -->
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- <table class="border-dashed w-full col-span-2 mt-2">
                      <thead>
                          <tr>
                              <td>No</td>
                              <td>{{$t('vaccines.description')}}</td>
                              <td>{{$t('candidate.submenu')}}</td>
                              <td>{{$t('lessonplan.file')}}</td>
                              <td></td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(attachment, index) in attachmentData.value.filter(item => item.submenu === 'Education')" :key="index">
                              <td>{{ index+1 }}</td>
                              <td>{{ attachment.description }}</td>
                              <td>{{ attachment.submenu }}</td>
                              <td>{{ attachment.filename }}</td>
                              <td></td>
                          </tr>
                      </tbody>
                  </table> -->
          </div>

          <div v-if="activeTab === 8" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Certification')"
              />

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('Certification')"
              />
            </div>

            <div class="table-content">
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Certificate Name</th>
                    <th>Issuer {{ $t("certification.institution") }}</th>
                    <th>Expired Date</th>
                    <th>{{ $t("vaccines.description") }}</th>
                    <th>{{ $t("lessonplan.file") }}</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(certification, index) in certificateData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ certification.certificate }}</td>
                    <td>{{ certification.institute }}</td>
                    <td>{{ certification.expired_date }}</td>
                    <td>{{ certification.remarks }}</td>
                    <td>{{ certification.file }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <jb-button
                          color="warning"
                          :icon="mdiDownload"
                          small
                          @click="download('Certification', certification.file)"
                        />
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="deleteFile(certification, 'certification')"
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="editData('Certification', certification)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Certification', certification)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- <table class="border-dashed w-full col-span-2 mt-2">
                      <thead>
                          <tr>
                              <td>No</td>
                              <td>{{$t('vaccines.description')}}</td>
                              <td>{{$t('candidate.submenu')}}</td>
                              <td>{{$t('lessonplan.file')}}</td>
                              <td></td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(attachment, index) in attachmentData.value.filter(item => item.submenu === 'Certification')" :key="index">
                              <td>{{ index+1 }}</td>
                              <td>{{ attachment.description }}</td>
                              <td>{{ attachment.submenu }}</td>
                              <td>{{ attachment.filename }}</td>
                              <td></td>
                          </tr>
                      </tbody>
                  </table> -->
          </div>

          <div v-if="activeTab === 9" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Work')"
              />

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('Work')"
              />
            </div>

            <div ref="modalContent" class="table-content">
              <p v-if="showActionColumn == false">
                Menu: <i>Work Expirence</i>
              </p>
              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>{{ $t("employee.startYear") }}</th>
                    <th>{{ $t("employee.endYear") }}</th>
                    <th>Employer</th>
                    <th>Last Position</th>
                    <th>{{ $t("vaccines.description") }}</th>
                    <th>Last Salary</th>
                    <th>Recommendation File</th>
                    <th v-if="showActionColumn">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(work, index) in workingData.value" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ work.startyear }}</td>
                    <td>{{ work.endyear }}</td>
                    <td>{{ work.place }}</td>
                    <td>{{ work.position }}</td>
                    <td>{{ work.remarks }}</td>
                    <td>{{ work.salary }}</td>
                    <td>{{ work.file }}</td>
                    <td v-if="showActionColumn">
                      <div class="table-buttons-action">
                        <jb-button
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          :disabled="!checkUser"
                          @click="deleteFile(work, 'workexp')"
                        />
                        <jb-button
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          :disabled="!checkUser"
                          @click="editData('Work', work)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Work', work)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- <table class="border-dashed w-full col-span-2 mt-2">
                      <thead>
                          <tr>
                              <td>No</td>
                              <td>{{$t('vaccines.description')}}</td>
                              <td>{{$t('candidate.submenu')}}</td>
                              <td>{{$t('lessonplan.file')}}</td>
                              <td></td>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(attachment, index) in attachmentData.value.filter(item => item.submenu === 'Work')" :key="index">
                              <td>{{ index+1 }}</td>
                              <td>{{ attachment.description }}</td>
                              <td>{{ attachment.submenu }}</td>
                              <td>{{ attachment.filename }}</td>
                              <td></td>
                          </tr>
                      </tbody>
                  </table> -->
          </div>

          <div v-if="activeTab === 10" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                :disabled="!checkUser"
                @click="addData('Family')"
              />
            </div>

            <div ref="modalContent" class="table-content">
              <p v-if="showActionColumn == false" class="mb-4">
                Menu: <i>Employee Family</i>
              </p>

              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>{{ $t("class.name") }}</th>
                    <th>{{ $t("family.relation") }}</th>
                    <th>{{ $t("employee.dateOfBirth") }}</th>
                    <th>{{ $t("family.isEmployee") }}</th>
                    <th>{{ $t("family.isStudent") }}</th>
                    <th>{{ $t("employee.mobileNum") }}</th>
                    <th>{{ $t("employee.email") }}</th>
                    <th>Remarks</th>
                    <th>Is Done</th>
                    <th v-if="showActionColumn">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(family, index) in familyData" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ family.name }}</td>
                    <td>{{ family.relation }}</td>
                    <td>{{ family.date_of_birth }}</td>
                    <td>{{ family.is_employee ? "Yes" : "No" }}</td>
                    <td>{{ family.is_student ? "Yes" : "No" }}</td>
                    <td>{{ family.mobile_no }}</td>
                    <td>{{ family.email }}</td>
                    <td>{{ family.remarks }}</td>
                    <td>
                      <div
                        v-if="family.relation == 'Children'"
                        class="table-buttons-action"
                      >
                        <jb-button
                          v-if="!family.is_done || family.is_done == false"
                          color="grey"
                          style="background-color: grey; color: white"
                          :icon="mdiCheckCircle"
                          small
                          @click="updateEmpDone(true, family)"
                        />
                        <jb-button
                          v-else
                          color="success"
                          :icon="mdiCheckCircle"
                          small
                          @click="updateEmpDone(false, family)"
                        />
                      </div>
                    </td>
                    <td v-if="showActionColumn">
                      <div class="table-buttons-action">
                        <jb-button
                          :disabled="!checkUser"
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          @click="deleteFile(family, 'family')"
                        />
                        <jb-button
                          :disabled="!checkUser"
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          @click="editData('Family', family)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Family', family)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 11" class="table-container">
            <div class="flex flex-wrap -mx-3 mb-1 w-8/12">
              <field
                :label="$t('presence.month') + '/' + $t('presence.year')"
                class="w-full md:w-2/2 px-2 mb-3 md:mb-1"
              >
                <datepicker
                  v-model="filter.date"
                  :enableTimePicker="false"
                  name="date"
                  monthPicker
                />
                <jb-button
                  label="Process"
                  color="info"
                  :icon="mdiMagnify"
                  small
                  @click="filterData"
                />
              </field>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{ $t("academicyear.date") }}</th>
                  <th>{{ $t("day.title") }}</th>
                  <th>{{ $t("presence.in") }}</th>
                  <th>{{ $t("presence.out") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(value, key) in presenceData"
                  :key="key"
                  :style="value !== null ? value[3] : ''"
                >
                  <td v-if="key === 'total_present'">
                    {{ $t("newbatchregis.total") + " " + $t("presence.title") }}
                  </td>
                  <td v-else-if="key === 'total_tardy'">
                    {{ $t("newbatchregis.total") + " " + $t("presence.tardy") }}
                  </td>
                  <td v-else-if="key === 'total_libur'">
                    {{
                      $t("newbatchregis.total") + " " + $t("presence.holiday")
                    }}
                  </td>
                  <td v-else>{{ key }}</td>

                  <td
                    v-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '0'
                    "
                  >
                    {{ $t("day.sunday") }}
                  </td>
                  <td
                    v-else-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '1'
                    "
                  >
                    {{ $t("day.monday") }}
                  </td>
                  <td
                    v-else-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '2'
                    "
                  >
                    {{ $t("day.tuesday") }}
                  </td>
                  <td
                    v-else-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '3'
                    "
                  >
                    {{ $t("day.wednesday") }}
                  </td>
                  <td
                    v-else-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '4'
                    "
                  >
                    {{ $t("day.thursday") }}
                  </td>
                  <td
                    v-else-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '5'
                    "
                  >
                    {{ $t("day.friday") }}
                  </td>
                  <td
                    v-else-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[0] === '6'
                    "
                  >
                    {{ $t("day.saturday") }}
                  </td>
                  <td v-else></td>

                  <td
                    v-if="
                      value !== null &&
                      typeof value[1] === 'string' &&
                      value[1].includes('late')
                    "
                  >
                    <span
                      class="relative inline-block px-3 py-1 font-semibold text-red-900 leading-tight"
                    >
                      <span
                        aria-hidden
                        class="absolute inset-0 bg-red-200 opacity-50 rounded-full"
                      />
                      <span class="relative">
                        {{ value[1].replace("late", "") }}
                      </span>
                    </span>
                  </td>
                  <td v-else-if="value !== null">{{ value[1] }}</td>
                  <td v-else></td>

                  <td v-if="value !== null">{{ value[2] }}</td>
                  <td v-else></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="activeTab === 12" class="table-container">
            <div class="mt-5">
              <calendar-attendance :prop-object="employee" />
            </div>
          </div>

          <div v-if="activeTab === 13" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                :disabled="!checkUser"
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addData('attachment')"
              />
              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('attachment')"
              />
            </div>

            <div ref="modalContent" class="table-content">
              <p v-if="showActionColumn == false" class="mb-4">
                Menu: <i>Attachment</i>
              </p>

              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>{{ $t("vaccines.description") }}</th>
                    <th>{{ $t("candidate.submenu") }}</th>
                    <th>{{ $t("lessonplan.file") }}</th>
                    <th v-if="showActionColumn">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(attachment, index) in attachmentData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ attachment.description }}</td>
                    <td>{{ attachment.submenu }}</td>
                    <td>{{ attachment.file }}</td>
                    <td v-if="showActionColumn">
                      <div class="table-buttons-action">
                        <jb-button
                          :disabled="!checkUser"
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          @click="deleteFile(attachment, 'employeeattachment')"
                        />
                        <jb-button
                          :disabled="!checkUser"
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          @click="editData('', attachment)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('', attachment)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 14" class="table-container">
            <div class="employee-buttons-action">
              <jb-button
                :disabled="!checkUser"
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addData('Appreciation')"
              />

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('Appreciation')"
              />
            </div>

            <div ref="modalContent" class="table-content">
              <p v-if="showActionColumn == false" class="mb-4">
                Menu: <i>Appreciation</i>
              </p>

              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Certificate Date</th>
                    <th>Achievement</th>
                    <th>Expired Date</th>
                    <th>File</th>
                    <th v-if="showActionColumn">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(appreciation, index) in appreciationData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ appreciation.certificate_date }}</td>
                    <td>{{ appreciation.achievement }}</td>
                    <td>{{ appreciation.expired_date }}</td>
                    <td>{{ appreciation.file }}</td>
                    <td v-if="showActionColumn">
                      <div class="table-buttons-action">
                        <jb-button
                          :disabled="!checkUser"
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          @click="
                            deleteFile(appreciation, 'employeappreciation')
                          "
                        />
                        <jb-button
                          :disabled="!checkUser"
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          @click="editData('Appreciation', appreciation)"
                        />
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('Appreciation', appreciation)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 15" class="table-container">
            <!-- <div class="employee-buttons-action">
              <jb-button
                v-if="checkUser"
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addData('punishmentTransaction')"
              />
            </div> -->

            <div ref="modalContent" class="table-content">
              <p v-if="showActionColumn == false" class="mb-4">
                Menu: <i>Warning</i>
              </p>

              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Number</th>
                    <th>Violation</th>
                    <th>Punishment</th>
                    <th>Transaction Date</th>
                    <th>Expired Date</th>
                    <th>Decree No</th>
                    <th>File Name</th>
                    <th>Remarks</th>
                    <th>Proposed By</th>
                    <th>HR Pic 1</th>
                    <th>HR Pic 2</th>
                    <th>Witness 1</th>
                    <th>Witness 2</th>
                    <th v-if="showActionColumn">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(
                      punishmentTransaction, index
                    ) in punishmentTransactionData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ punishmentTransaction.number }}</td>
                    <td>{{ punishmentTransaction.violation_description }}</td>
                    <td>{{ punishmentTransaction.punishment_description }}</td>
                    <td>{{ punishmentTransaction.transaction_date }}</td>
                    <td>{{ punishmentTransaction.expired_date }}</td>
                    <td>{{ punishmentTransaction.decree_no }}</td>
                    <td>{{ punishmentTransaction.file_name }}</td>
                    <td>{{ punishmentTransaction.remarks }}</td>
                    <td>{{ punishmentTransaction.proposed_by_name }}</td>
                    <td>{{ punishmentTransaction.pic1_name }}</td>
                    <td>{{ punishmentTransaction.pic2_name }}</td>
                    <td>{{ punishmentTransaction.witness1_name }}</td>
                    <td>{{ punishmentTransaction.witness2_name }}</td>
                    <td v-if="showActionColumn">
                      <div class="table-buttons-action">
                        <!-- <jb-button
                          v-if="checkUser"
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          @click="deleteFile(violation, 'employeviolation')"
                        />
                        <jb-button
                          v-if="checkUser"
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          @click="editData('Violation', violation)"
                        /> -->
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="
                            detailData(
                              'punishmentTransaction',
                              punishmentTransaction
                            )
                          "
                        />
                        <jb-button
                          :disabled="!checkUser"
                          color="info"
                          :icon="mdiFileSearchOutline"
                          small
                          @click="
                            viewFile(
                              'punishmentTransaction',
                              punishmentTransaction.id
                            )
                          "
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 16" class="table-container">
            <div class="employee-buttons-action">
              <!-- <jb-button
                v-if="checkUser"
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addData('programme')"
              /> -->

              <jb-button
                color="warning"
                label="Download"
                :icon="mdiDownload"
                small
                @click="downloadAllPDFs('programme')"
              />
            </div>

            <div ref="modalContent" class="table-content">
              <p v-if="showActionColumn == false" class="mb-4">
                Menu: <i>programme</i>
              </p>

              <table>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>School</th>
                    <th>Branch</th>
                    <th>Academic Year</th>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>File</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(programme, index) in programmeData.value"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ programme.school_name }}</td>
                    <td>{{ programme.branch_name }}</td>
                    <td>{{ programme.academic_year_name }}</td>
                    <td>{{ programme.code }}</td>
                    <td>{{ programme.name }}</td>
                    <td>{{ programme.description }}</td>
                    <td>{{ programme.start_date }}</td>
                    <td>{{ programme.end_date }}</td>
                    <td>{{ programme.file_name }}</td>
                    <td>
                      <div class="table-buttons-action">
                        <!-- <jb-button
                          v-if="checkUser"
                          color="danger"
                          :icon="mdiTrashCan"
                          small
                          @click="deleteFile(programme, 'programme')"
                        />
                        <jb-button
                          v-if="checkUser"
                          color="info"
                          :icon="mdiCircleEditOutline"
                          small
                          @click="editData('programme', programme)"
                        /> -->
                        <jb-button
                          color="warning"
                          :icon="mdiMagnify"
                          small
                          @click="detailData('programme', programme)"
                        />
                        <jb-button
                          :disabled="!checkUser"
                          color="info"
                          :icon="mdiFileSearchOutline"
                          small
                          @click="viewFile('programme', programme.id)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="activeTab === 17" class="table-container">
            <div class="w-full flex justify-center items-center gap-2">
              <!-- <jb-button class="mb-2" label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addData('Assesment')" /> -->
            </div>
            <div ref="modalContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal close -->
  <div
    class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default"
    v-show="uploadModal"
    @click="uploadModal = false"
  />

  <!-- history modal -->
  <vue-final-modal
    v-model="employeeHistoryModal"
    classes="base-modal"
    :ssr="true"
    :content-class="'add-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t("employee.update_history") }}</h1>
      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="showEmployeeHistory()"
      />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <EmployeeHistory
        :employeeHistory="employeeHistoryData"
        :checkUser="checkUser"
        @close-modal="showEmployeeHistory()"
        @refresh-list="refreshList()"
      />
    </div>
  </vue-final-modal>

  <vue-final-modal
    v-model="employeeModal"
    classes="base-modal"
    :ssr="true"
    :content-class="'add-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t("employee.editform") }}</h1>
      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="editDataEmployee()"
      />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <EmployeeForm
        :prop-class="employee"
        :show-edit="true"
        :checkUser="checkUser"
        @close-modal="editDataEmployee()"
        @refresh-list="refreshList()"
      />
    </div>
  </vue-final-modal>

  <vue-final-modal
    v-model="uploadModal"
    classes="base-modal"
    :ssr="true"
    :content-class="
      darkMode
        ? 'add-modal bg-darkmode-base transition-colors duration-1000'
        : 'add-modal bg-white transition-colors duration-1000'
    "
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="where.submenu === 'Position'">Position Form</h1>
      <h1 v-else-if="where.submenu === 'Branch'">Branch Form</h1>
      <h1 v-else-if="where.submenu === 'Contract'">Contract Form</h1>
      <h1 v-else-if="where.submenu === 'employeecareerpath'">
        Employee Career Path Form
      </h1>
      <h1 v-else-if="where.submenu === 'Retirement'">Retirement Form</h1>
      <h1 v-else-if="where.submenu === 'employeetraining'">Training Form</h1>
      <h1 v-else-if="where.submenu === 'Education'">Educational Record Form</h1>
      <h1 v-else-if="where.submenu === 'Certification'">Certification Form</h1>
      <h1 v-else-if="where.submenu === 'Work'">Working Experiences Form</h1>
      <h1 v-else-if="where.submenu === 'Family'">Family Form</h1>
      <h1 v-else-if="where.submenu === 'Appreciation'">Appreciation Form</h1>
      <h1 v-else-if="where.submenu === 'programme'">Programme Form</h1>
      <h1 v-else-if="where.submenu === 'punishmentTransaction'">
        Warning Form
      </h1>
      <h1 v-else>Add Form</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="uploadModal = false"
      />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <position-form
        v-if="where.submenu === 'Position'"
        :prop-class="where"
        :prop-object="EditObject"
        :prop-position="positionData.value"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <employee-career-path-form
        v-else-if="where.submenu === 'employeecareerpath'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <branch-form
        v-else-if="where.submenu === 'Branch'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <contract-form
        v-else-if="where.submenu === 'Contract'"
        :prop-class="where"
        :prop-employee-contract="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
        @reset-modal="resetModal"
      />
      <employee-training-form
        v-else-if="where.submenu === 'employeetraining'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <retirement-form
        v-else-if="where.submenu === 'Retirement'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <edu-form
        v-else-if="where.submenu === 'Education'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <certification-form
        v-else-if="where.submenu === 'Certification'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <work-form
        v-else-if="where.submenu === 'Work'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <family-form
        v-else-if="where.submenu === 'Family'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <appreciation-form
        v-else-if="where.submenu === 'Appreciation'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <programme-form
        v-else-if="where.submenu === 'programme'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <violation-form
        v-else-if="where.submenu === 'Violation'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <punishment-transaction-form
        v-else-if="where.submenu === 'punishmentTransaction'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <upload-form
        v-else
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
    </div>
  </vue-final-modal>

  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="where.submenu === 'Position'">Position Detail</h1>
      <h1 v-else-if="where.submenu === 'employeecareerpath'">
        Employee Career Path Detail
      </h1>
      <h1 v-else-if="where.submenu === 'Branch'">Branch Detail</h1>
      <h1 v-else-if="where.submenu === 'Contract'">Contract Detail</h1>
      <h1 v-else-if="where.submenu === 'Retirement'">Retirement Detail</h1>
      <h1 v-else-if="where.submenu === 'employeetraining'">Training Detail</h1>
      <h1 v-else-if="where.submenu === 'Education'">
        Educational Record Detail
      </h1>
      <h1 v-else-if="where.submenu === 'Certification'">
        Certification Detail
      </h1>
      <h1 v-else-if="where.submenu === 'Work'">Working Experiences Detail</h1>
      <h1 v-else-if="where.submenu === 'Family'">Family Detail</h1>
      <h1 v-else-if="where.submenu === 'Appreciation'">Appreciation Detail</h1>
      <h1 v-else-if="where.submenu === 'programme'">Programme Detail</h1>
      <h1 v-else-if="where.submenu === 'punishmentTransaction'">
        Warning Detail
      </h1>
      <h1 v-else-if="where.submenu === 'document'">Document Detail</h1>
      <h1 v-else>Detail</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="detailModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <position-detail
        v-if="where.submenu === 'Position'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <employee-career-path-detail
        v-else-if="where.submenu === 'employeecareerpath'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <branch-detail
        v-else-if="where.submenu === 'Branch'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <contract-detail
        v-else-if="where.submenu === 'Contract'"
        :prop-class="where"
        :prop-employee-contract="EditObject"
        @close-modal="hideModal"
      />
      <employee-training-detail
        v-else-if="where.submenu === 'employeetraining'"
        :prop-class="where"
        :propEmployeeTraining="EditObject"
        @close-modal="hideModal"
      />
      <retirement-detail
        v-else-if="where.submenu === 'Retirement'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <edu-detail
        v-else-if="where.submenu === 'Education'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <certification-detail
        v-else-if="where.submenu === 'Certification'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <work-detail
        v-else-if="where.submenu === 'Work'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <family-detail
        v-else-if="where.submenu === 'Family'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <appreciation-detail
        v-else-if="where.submenu === 'Appreciation'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <programme-detail
        v-else-if="where.submenu === 'programme'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <violation-detail
        v-else-if="where.submenu === 'Violation'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <punishment-transaction-detail
        v-else-if="where.submenu === 'punishmentTransaction'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <upload-detail
        v-else
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
    </div>
  </vue-final-modal>

  <!-- Modal Position Is Main Function -->
  <vue-final-modal
    v-model="informationModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Information</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="informationModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <div class="w-full px-4 py-6">
        <p>
          This Employee has been assigned for {{ mainup.position_name }} -
          {{ mainup.department_name }} as his / her Main Job. Do you want to
          change into this record as his / her Main Job?
        </p>
      </div>

      <jb-buttons
        class="flex justify-center w-full"
        style="padding: 15px !important"
      >
        <jb-button label="Yes" color="info" @click="updateMain" class="w-1/2" />
        <jb-button
          label="No"
          color="danger"
          outline
          @click="informationModal = false"
          class="w-2/5"
        />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <vue-final-modal
    v-model="positionActiveModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Information</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="positionActiveModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <div class="w-full px-4 py-6">
        <p>Are you sure you want to do this to the employee?</p>
      </div>

      <jb-buttons
        class="flex justify-center w-full"
        style="padding: 15px !important"
      >
        <jb-button
          label="Yes"
          color="info"
          @click="updateIsActive"
          class="w-1/2"
        />
        <jb-button
          label="No"
          color="danger"
          outline
          @click="positionActiveModal = false"
          class="w-2/5"
        />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <!-- view file modal -->
  <vue-final-modal
    v-model="viewFileModal"
    classes="base-modal"
    :ssr="true"
    content-class="medium-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Show file</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="viewFileModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <img
        :src="fileData.file"
        alt="Preview image"
        v-if="['png', 'jpg', 'jpeg'].includes(fileData.type)"
        style="width: 100%"
      />

      <!-- Show PDF using vue-pdf-embed -->
      <vue-pdf-embed
        v-else-if="fileData.type === 'pdf'"
        :source="fileData.file"
        style="width: 100% !important; height: 100% !important"
      />

      <!-- Fallback message -->
      <span class="text-4xl" v-else>File Not Found</span>
    </div>
  </vue-final-modal>

  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { ref, reactive, watchEffect, onMounted, computed, watch } from "vue";
import StudentAvatar from "@/components/StudentAvatar";
import Level from "@/components/Level";
import CardComponent from "@/components/CardComponent";
import { useStore } from "vuex";
// Form
import UploadForm from "@/views/referensi/employee/UploadForm";
import PositionForm from "@/views/referensi/employee/PositionForm";
import BranchForm from "@/views/referensi/employee/BranchForm";
// import ContractForm from "@/views/referensi/employee/ContractForm";
import ContractForm from "@/views/humanresource/employeeContract/EmployeeContractForm";
import RetirementForm from "@/views/referensi/employee/RetirementForm";
import EduForm from "@/views/referensi/employee/EduForm";
import CertificationForm from "@/views/referensi/employee/CertificationForm";
import WorkForm from "@/views/referensi/employee/WorkForm";
import FamilyForm from "@/views/referensi/employee/FamilyForm";
import AppreciationForm from "@/views/referensi/employee/AppreciationForm";
import ViolationForm from "@/views/referensi/employee/ViolationForm";
import PunishmentTransactionForm from "@/views/humanresource/punishmentTransaction/PunishmentTransactionForm";
import AssignmentForm from "@/views/referensi/employee/AssignmentForm";
import EmployeeCareerPathForm from "@/views/referensi/employeeCareerPath/EmployeeCareerPathForm";
import EmployeeTrainingForm from "@/views/humanresource/employeetraining/EmployeeTrainingForm";
import ProgrammeForm from "@/views/humanresource/programme/ProgrammeForm";
// Detail
import PositionDetail from "@/views/referensi/employee/PositionDetail";
import BranchDetail from "@/views/referensi/employee/BranchDetail";
// import ContractDetail from "@/views/referensi/employee/ContractDetail";
import ContractDetail from "@/views/humanresource/employeeContract/EmployeeContractDetail";
import UploadDetail from "@/views/referensi/employee/UploadDetail";
import RetirementDetail from "@/views/referensi/employee/RetirementDetail";
import EduDetail from "@/views/referensi/employee/EduDetail";
import CertificationDetail from "@/views/referensi/employee/CertificationDetail";
import WorkDetail from "@/views/referensi/employee/WorkDetail";
import FamilyDetail from "@/views/referensi/employee/FamilyDetail";
import AppreciationDetail from "@/views/referensi/employee/AppreciationDetail";
import ViolationDetail from "@/views/referensi/employee/ViolationDetail";
import PunishmentTransactionDetail from "@/views/humanresource/punishmentTransaction/PunishmentTransactionDetail";
import AssignmentDetail from "@/views/referensi/employee/AssignmentDetail";
import EmployeeCareerPathDetail from "@/views/referensi/employeeCareerPath/EmployeeCareerPathDetail";
import EmployeeTrainingDetail from "@/views/humanresource/employeetraining/EmployeeTrainingDetail";
import ProgrammeDetail from "@/views/humanresource/programme//ProgrammeDetail";
import Pill from "@/components/Pill";
import ButtonActive from "@/components/ButtonActive";
import JbButton from "@/components/JbButton";
import Field from "@/components/Field";
import Control from "@/components/Control";
import {
  mdiCheckDecagram,
  mdiAlertDecagram,
  mdiPlusCircleOutline,
  mdiAccountEditOutline,
  mdiClose,
  mdiDownload,
  mdiTrashCan,
  mdiCircleEditOutline,
  mdiMagnify,
  mdiTextBoxSearch,
  mdiCheckCircle,
  mdiFileSearchOutline,
} from "@mdi/js";
import { getShift } from "@/composables/global";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main\.css";
import { useToast } from "vue-toastification";
import Loading from "vue-loading-overlay";
import html2pdf from "html2pdf.js";
import CryptoJS from "crypto-js";
import VuePdfEmbed from "vue-pdf-embed";
// Calendar
import CalendarAttendance from "@/views/referensi/employee/CalendarAttendance";
import { useI18n } from "vue-i18n";
import DefaultProfile from "@/assets/general/default-user.png";
import EmployeeForm from "@/views/referensi/employee/EmployeeForm";
import EmployeeHistory from "@/views/referensi/employee/EmployeeHistory";

export default {
  name: "ClassForm",
  components: {
    CalendarAttendance,
    StudentAvatar,
    Datepicker,
    Field,
    Control,
    Level,
    UploadForm,
    PositionForm,
    BranchForm,
    ContractForm,
    RetirementForm,
    EduForm,
    CertificationForm,
    WorkForm,
    FamilyForm,
    AppreciationForm,
    ViolationForm,
    PunishmentTransactionForm,
    AssignmentForm,
    EmployeeCareerPathForm,
    EmployeeTrainingForm,
    ProgrammeForm,
    ProgrammeDetail,
    EmployeeTrainingDetail,
    PositionDetail,
    BranchDetail,
    ContractDetail,
    UploadDetail,
    RetirementDetail,
    EduDetail,
    CertificationDetail,
    WorkDetail,
    FamilyDetail,
    AppreciationDetail,
    ViolationDetail,
    PunishmentTransactionDetail,
    AssignmentDetail,
    EmployeeCareerPathDetail,
    CardComponent,
    JbButton,
    ButtonActive,
    Pill,
    Loading,
    html2pdf,
    VuePdfEmbed,
    EmployeeForm,
    EmployeeHistory,
  },

  props: {
    propClass: { type: Object, default: () => ({ empty: true }) },
    isBranch: { type: Boolean, default: false },
    isDecree: { type: Boolean, default: false },
    isContract: { type: Boolean, default: false },
    isDocument: { type: Boolean, default: false },
    isRetire: { type: Boolean, default: false },
    isFamily: { type: Boolean, default: false },
    propId: { type: String, default: null },
    tabActive: { type: Number, default: 0 },
    monthActive: { type: Text, default: "" },
    checkUser: { type: Boolean, default: false },
  },

  emits: ["close-modal", "submit"],

  methods: {
    downloadAllPDFs(type) {
      let data;
      switch (type) {
        case "Position":
          data = this.positionData.value;
          break;
        case "Branch":
          data = this.branchData.value;
          break;
        case "Contract":
          data = this.contractData.value;
          break;
        case "Training":
          data = this.TrainingData.value;
          break;
        case "Education":
          data = this.educationData.value;
          break;
        case "Certification":
          data = this.certificateData.value;
          break;
        case "Work":
          data = this.workingData.value;
          break;
        case "attachment":
          data = this.attachmentData.value;
          break;
        case "Appreciation":
          data = this.appreciationData.value;
          break;
        case "Assignment":
          data = this.assignmentData.value;
          break;
        case "CareerPath":
          data = this.employeeCareerPathData;
          break;
        default:
          data = [];
      }
      data.forEach((item) => {
        const link = document.createElement("a");
        link.href = item.filename;
        link.download = `${item.file ? item.file : item.file_name}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const titleStack = ref(["Admin", "Forms"]);
    const activeTab = ref(0);
    const uploadModal = ref(false);
    const detailModal = ref(false);
    const toast = useToast();
    const where = reactive({
      ein: "",
      submenu: "",
      nickname: "",
    });
    const { shiftList } = getShift();
    const presenceData = ref([]);
    const positionData = reactive([]);
    const viewFileModal = ref(false);
    const employeeCareerPathData = ref([]);
    const branchData = reactive([]);
    const contractData = reactive([]);
    const educationData = reactive([]);
    const certificateData = reactive([]);
    const workingData = reactive([]);
    const familyData = ref([]);
    const retireData = reactive([]);
    const attachmentData = reactive([]);
    const TrainingData = reactive([]);
    const employeeTrainingData = reactive([]);
    const appreciationData = reactive([]);
    const violationData = reactive([]);
    const punishmentTransactionData = reactive([]);
    const assignmentData = reactive([]);
    const programmeData = reactive([]);
    const fileidcard = ref("");
    const filefamilycard = ref("");
    const filepassport = ref("");
    const filetin = ref("");
    const str = useStore();
    const userlogin = localStorage.getItem("name");
    const isLoading = ref(false);
    const employeeHistoryData = ref([]);

    const employee = reactive({
      id: "",
      description: "",
      photo: "",
      created_by: "",
    });
    const filter = reactive({
      shift_id: "",
      date: {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      },
    });

    const details = async (evt) => {
      isLoading.value = true;
      const params = reactive({
        id: evt,
      });
      await axios
        .get("employeedetails", {
          params: params,
        })
        .then((response) => {
          // assign state kelass with response data
          positionData.value = response.data.position;
          branchData.value = response.data.branch;
          contractData.value = response.data.contract;
          // salaryData.value = response.data.salary
          educationData.value = response.data.school;
          certificateData.value = response.data.certificate;
          workingData.value = response.data.workexp;
          familyData.value = response.data.family;
          retireData.value = response.data.retire;
          // attachmentData.value = response.data.attachment
          TrainingData.value = response.data.attachment.filter(
            (item) => item.submenu == "Training"
          );
          attachmentData.value = response.data.attachment.filter(
            (item) => item.submenu !== "Training"
          );
          appreciationData.value = response.data.appreciation;
          assignmentData.value = response.data.assignment;
          employeeCareerPathData.value = response.data.employeecareerpath;
          employeeTrainingData.value = response.data.employeetraining;
          programmeData.value = response.data.programme;
          punishmentTransactionData.value = response.data.punishmentTransaction;
          violationData.value = response.data.violation;

          isLoading.value = false;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const filterData = async () => {
      isLoading.value = true;
      const params = reactive({
        id: props.propId,
        shift_id: filter.shift_id,
        work_unit_id: employee.work_unit_id,
        month: filter.date.month + 1,
        year: filter.date.year,
      });
      await axios
        .get("presenceemployee", {
          params: params,
        })
        .then((response) => {
          // assign state kelass with response data
          presenceData.value = response.data.data[0];
          isLoading.value = false;
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const hideModal = () => {
      uploadModal.value = false;
      details(props.propId);
    };

    const onFileChange = async (event, evt) => {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 1024 * 1024) {
          alert("File too big (> 1MB)");
          file.value = "";
        } else {
          const reader = new FileReader();
          reader.onloadend = function () {
            if (evt === "idcard") {
              fileidcard.value = reader.result;
            } else if (evt === "familycard") {
              filefamilycard.value = reader.result;
            } else if (evt === "passport") {
              filepassport.value = reader.result;
            } else {
              filetin.value = reader.result;
            }
          };
          reader.readAsDataURL(file);
        }
      } else {
        fileidcard.value = "";
      }
    };

    const showActionColumn = ref(true);

    const modalContent = ref(null);

    const download = async (submenu) => {
      isLoading.value = false;
      showActionColumn.value = false;
      const currentDate = new Date().toISOString().slice(0, 10);
      const content = modalContent.value;
      html2pdf(content, {
        margin: 0.5,
        filename: `${currentDate}_${submenu}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          width: 8.5,
        },
      })
        .then(() => {
          isLoading.value = false;
          showActionColumn.value = true;
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
          isLoading.value = false;
        });
    };

    const deleteFile = (evt, url) => {
      if (!checkUser.value) return;
      isLoading.value = true;
      axios
        .delete(`${url}/${evt.id}`)
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            toast.success(response.data.message, { timeout: 5000 });
          } else {
            toast.error(response.data.message, { timeout: 5000 });
          }
          isLoading.value = false;
        })
        .catch((error) => {
          console.log(error);
          details(props.propId);
          toast.error(error.response.data.message, { timeout: 5000 });

          isLoading.value = false;
        });
    };

    const resetModal = () => {
      where.submenu = "";
      where.ein = "";
      where.nickname = "";
      where.employee_id = "";
    };

    // const addData = (evt) => {
    //   if (!checkUser.value) return;
    //   uploadModal.value = true;
    //   resetModal();
    //   where.submenu = evt;
    //   where.ein = employee.ein;
    //   where.nickname = employee.nickname;
    //   where.employee_id = props.propId;
    //   showEdit.value = false;

    //   console.log("Buka Modal", where);
    // };

    const addData = (evt) => {
      if (!checkUser.value) return;

      // RESET STATE EDIT DULU
      showEdit.value = false;
      EditObject.value = null;

      resetModal();

      uploadModal.value = true;
      where.submenu = evt;
      where.ein = employee.ein;
      where.nickname = employee.nickname;
      where.employee_id = props.propId;

      console.log("Buka Modal (ADD)", where);
    };

    const showEdit = ref(false);

    const EditObject = ref();

    const editData = (submenuValue, position) => {
      if (!checkUser.value) return;
      uploadModal.value = true;
      where.submenu = submenuValue;
      where.ein = employee.ein;
      where.nickname = employee.nickname;
      where.employee_id = props.propId;
      EditObject.value = position;
      showEdit.value = true;
    };

    const detailData = (submenuValue, position) => {
      where.submenu = submenuValue;
      // where.ein = employee.ein
      // where.nickname = employee.nickname
      // where.employee_id = props.propId
      detailModal.value = true;
      EditObject.value = position;

      // console.log("editObject.value", EditObject.value);
    };

    const image = reactive({
      get: null,
    });

    const getPhoto = () => {
      // console.log(" employee id GET PHOTO", props.propId);
      axios
        .get("get-photo-employee", {
          params: { id: props.propId },
        })
        .then((res) => {
          if (res.data.success) {
            image.get = res.data.data;
          }
        })
        .catch((error) => {
          console.log("error", error);
          // getPhotoDoc()
        });
    };

    const userRole = localStorage.getItem("roles");

    const checkUser = ref(false);
    const userCheck = async () => {
      if (userRole !== null) {
        const decryptedMessage = CryptoJS.AES.decrypt(
          localStorage.getItem("role"),
          "amatra1609"
        ).toString(CryptoJS.enc.Utf8);
        const myArray = decryptedMessage.split(",");
        for (let i = 0; i < myArray.length; i++) {
          if (
            myArray[i] === "ROLE_ADMIN" ||
            myArray[i] === "ROLE_ADMIN_HRD" ||
            myArray[i] === "ROLE_SUPER_ADMIN" ||
            myArray[i] === "ROLE_MANAGEMENT"
          ) {
            checkUser.value = true;
          }
        }
      }
    };

    const headers = { "Content-Encoding": "gzip" };

    const fetchData = async () => {
      if (!props.propId) return;
      isLoading.value = true;
      const params = reactive({
        id: props.propId,
      });
      try {
        const [responseEmployeeDetail, responeEmployeeHistory] =
          await Promise.all([
            axios.get("employeedetails", { headers, params: params }),
            axios.get("audit-logs", {
              headers,
              params: { table_name: "m_employee", record_id: props.propId },
            }),
          ]);
        if (responseEmployeeDetail.data.success) {
          positionData.value = responseEmployeeDetail.data.position;
          branchData.value = responseEmployeeDetail.data.branch;
          contractData.value = responseEmployeeDetail.data.contract;
          // salaryData.value = responseEmployeeDetail.data.salary
          educationData.value = responseEmployeeDetail.data.school;
          certificateData.value = responseEmployeeDetail.data.certificate;
          workingData.value = responseEmployeeDetail.data.workexp;
          familyData.value = responseEmployeeDetail.data.family;
          retireData.value = responseEmployeeDetail.data.retire;
          // attachmentData.value = responseEmployeeDetail.data.attachment
          TrainingData.value = responseEmployeeDetail.data.attachment.filter(
            (item) => item.submenu == "Training"
          );
          attachmentData.value = responseEmployeeDetail.data.attachment.filter(
            (item) => item.submenu !== "Training"
          );
          appreciationData.value = responseEmployeeDetail.data.appreciation;
          assignmentData.value = responseEmployeeDetail.data.assignment;
          employeeCareerPathData.value =
            responseEmployeeDetail.data.employeecareerpath;
          employeeTrainingData.value =
            responseEmployeeDetail.data.employeetraining;
          programmeData.value = responseEmployeeDetail.data.programme;
          punishmentTransactionData.value =
            responseEmployeeDetail.data.punishmentTransaction;
          violationData.value = responseEmployeeDetail.data.violation;
        }
        if (responeEmployeeHistory.data.success) {
          employeeHistoryData.value = responeEmployeeHistory.data.data.data;
        }
        console.log("Cek response employee details", responseEmployeeDetail);
        isLoading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return "-";
      return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(new Date(dateStr));
    };

    onMounted(() => {
      userCheck();
    });

    watchEffect(() => {
      const newemployee = props.propClass;
      Object.assign(employee, newemployee);
      fetchData();
      if (props.isRetire) {
        activeTab.value = 0;
      }

      if (props.isDecree) {
        activeTab.value = 2;
      }

      if (props.isContract) {
        activeTab.value = 6;
      }

      if (props.isDocument) {
        activeTab.value = 8;
      }

      if (props.isFamily) {
        activeTab.value = 10;
      }

      if (props.tabActive) {
        activeTab.value = props.tabActive;
      }
    });

    watch(
      () => props.propId,
      (newVal, oldVal) => {
        // console.log("Get id employee", newVal);
        if (newVal) {
          getPhoto(newVal);
        } else {
          image.get = null;
        }
        // details(newVal);
        // filterData();
        fetchData();

        if (newVal && props.monthActive) {
          filter.date.month = parseInt(props.monthActive.slice(5, 7)) - 1;
          filter.date.year = Number(props.monthActive.slice(0, 4));

          if (filter.date.month && filter.date.year) {
            filterData();
          }
        }
      }
    );

    watch(
      () => props.isBranch,
      (newVal, oldVal) => {
        if (props.isBranch) {
          activeTab.value = 3;
        }
      }
    );

    // watch(() => props.tabActive, (newAct, oldAct) => {
    //   if(newAct) {
    //     activeTab.value = newAct
    //   }
    // })

    // watch(
    //   () => props.isDecree,
    //   (newVal, oldVal) => {
    //     console.log("cel decre ges", props.isDecree)
    //     if (props.isDecree) {
    //       activeTab.value = 2;
    //     }
    //   }
    // );

    // watch(
    //   () => props.isDocument,
    //   (newVal, oldVal) => {
    //     if (props.isDocument) {
    //       activeTab.value = 8;
    //     }
    //   }
    // );

    const mainup = reactive({
      id: "",
      employee_id: "",
      is_main: true,
      department_name: "",
      position_name: "",
      updated_by: "",
    });
    const informationModal = ref(false);
    const updateMainData = (is_main, data) => {
      if (!checkUser.value) return;
      informationModal.value = true;
      mainup.id = data.id;
      mainup.employee_id = data.employee_id;
      mainup.is_main = is_main;
      mainup.department_name = data.department_name;
      mainup.position_name = data.position_name;
      mainup.updated_by = userlogin;
    };

    const updateMain = () => {
      isLoading.value = true;
      const url = "employeeposition-main";
      const method = "POST";
      const params = mainup;
      // console.log("params", params);

      const jsonData = JSON.stringify(params);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            informationModal.value = false;
            toast.success(response.data.message);
          } else {
            isLoading.value = false;
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const positionActiveModal = ref(false);
    const isActiveData = reactive({
      id: "",
      employee_id: "",
      is_active: true,
      updated_by: "",
    });

    const updateActiveData = (is_active, data) => {
      if (!checkUser.value) return;
      positionActiveModal.value = true;
      isActiveData.id = data.id;
      isActiveData.employee_id = data.employee_id;
      isActiveData.position_id = data.position_id;
      isActiveData.tmt = data.tmt;
      isActiveData.is_main = data.is_main;
      isActiveData.is_active = is_active;
      isActiveData.updated_by = userlogin;
    };

    const updateIsActive = () => {
      isLoading.value = true;
      const url = "employeeposition/" + isActiveData.id;
      const method = "PUT";
      const params = isActiveData;
      // console.log("params", params);

      const jsonData = JSON.stringify(params);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            positionActiveModal.value = false;
            toast.success(response.data.message);
          } else {
            isLoading.value = false;
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const viewFile = (event, id) => {
      viewFileModal.value = true;
      viewFileModal.id = id;
      getFile();
    };

    const fileData = ref({
      file: "",
      type: "",
    });

    const getFile = async () => {
      isLoading.value = true;
      await axios
        .get("show-file-punishment/" + viewFileModal.id)
        .then((response) => {
          if (response.data.success) {
            fileData.value = response.data.data;
          } else {
            fileData.value = [];
          }
          isLoading.value = false;
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const employeeModal = ref(false);
    const editDataEmployee = () => {
      if (!employeeModal.value) {
        employeeModal.value = true;
      } else {
        employeeModal.value = false;
      }
    };

    const refreshList = () => {
      emit("refresh-list", employee.id);
    };

    const updateCarClosed = (type, data) => {
      if (!checkUser.value) return;
      isLoading.value = true;

      const url = "put-employee-career/" + data.id;
      const method = "PUT";
      const params = {
        is_closed: type,
        updated_by: localStorage.getItem("admin"),
      };

      const jsonData = JSON.stringify(params);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axios({ method, url, data: jsonData, headers: configHeaders })
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            uploadModal.value = false;
            toast.success(response.data.message);
          } else {
            isLoading.value = false;
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const updateEmpDone = (type, data) => {
      if (!checkUser.value) return;
      isLoading.value = true;

      const url = "put-employee-family/" + data.id;
      const method = "PUT";
      const params = {
        is_done: type,
        updated_by: localStorage.getItem("admin"),
      };

      const jsonData = JSON.stringify(params);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axios({ method, url, data: jsonData, headers: configHeaders })
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            uploadModal.value = false;
            toast.success(response.data.message);
          } else {
            isLoading.value = false;
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const wordFile = async (event, contractId) => {
      try {
        isLoading.value = true;

        downloadContractFile(contractId);
      } catch (err) {
        console.error(err);
        toast.error("Failed to download file", { timeout: 4000 });
      } finally {
        isLoading.value = false;
      }
    };

    const downloadContractFile = (employeeContractId, fileName) => {
      isLoading.value = true;

      axios
        .get(`/employee-contract/${employeeContractId}/download-word`, {
          responseType: "blob",
        })
        .then((response) => {
          const downloadName =
            fileName || `Employee_Contract_${employeeContractId}.docx`;

          triggerDownload(response.data, downloadName);

          toast.success(`Downloaded Successfully`, { timeout: 3000 });
        })
        .catch((error) => {
          console.error("Download contract file failed:", error);
          toast.error(
            error.response?.data?.message || "Failed to download file",
            {
              timeout: 5000,
            }
          );
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const triggerDownload = (blobData, filename) => {
      const fileURL = window.URL.createObjectURL(new Blob([blobData]));

      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", filename);

      document.body.appendChild(fileLink);
      fileLink.click();

      document.body.removeChild(fileLink);
      window.URL.revokeObjectURL(fileURL);
    };

    const tabs = [
      { index: 0, name: t("employee.personal"), sorting_no: 0 },
      { index: 3, name: t("employee.branch"), sorting_no: 1 },
      { index: 7, name: "Educational Record", sorting_no: 2 },
      { index: 8, name: "Certification", sorting_no: 3 },
      { index: 9, name: "Working Experiences", sorting_no: 4 },
      { index: 10, name: "Family", sorting_no: 5 },

      { index: 1, name: t("employee.position"), sorting_no: 6 },
      { index: 2, name: t("employee.careerPath"), sorting_no: 7 },
      { index: 6, name: t("employee.contract"), sorting_no: 8 },

      { index: 11, name: "Attendance", sorting_no: 9 },
      { index: 12, name: "Attendance Calendar", sorting_no: 10 },

      { index: 16, name: t("employee.assignment"), sorting_no: 11 },
      { index: 14, name: "Accomplishment", sorting_no: 12 },
      // { index: 4, name: t("employee.retirement"), sorting_no: 0 },

      { index: 15, name: "Warning", sorting_no: 13 },
      { index: 5, name: t("employee.training"), sorting_no: 14 },
      { index: 17, name: t("Overtime"), sorting_no: 15 },
      { index: 13, name: "Personal Document", sorting_no: 16 },
      // { index: 17, name: "Assesment" },
    ];

    const sortedTabs = [...tabs].sort((a, b) => a.sorting_no - b.sorting_no);

    const employeeHistoryModal = ref(false);
    const showEmployeeHistory = () => {
      if (!employeeHistoryModal.value) {
        employeeHistoryModal.value = true;
      } else {
        employeeHistoryModal.value = false;
      }
    };

    return {
      DefaultProfile,
      checkUser,
      updateMain,
      updateMainData,
      updateActiveData,
      updateIsActive,
      informationModal,
      positionActiveModal,
      mainup,
      activeTab,
      sortedTabs,
      titleStack,
      shiftList,
      str,
      userlogin,
      uploadModal,
      toast,
      where,
      filter,
      filterData,
      hideModal,
      onFileChange,
      download,
      deleteFile,
      addData,
      editData,
      detailData,
      detailModal,
      viewFileModal,
      viewFile,
      EditObject,
      showEdit,
      mdiCheckDecagram,
      mdiClose,
      mdiAlertDecagram,
      mdiPlusCircleOutline,
      mdiAccountEditOutline,
      mdiDownload,
      mdiTrashCan,
      mdiCircleEditOutline,
      mdiCheckCircle,
      mdiMagnify,
      mdiTextBoxSearch,
      mdiFileSearchOutline,
      employee,
      presenceData,
      // trainingData,
      positionData,
      employeeCareerPathData,
      employeeTrainingData,
      programmeData,
      punishmentTransactionData,
      branchData,
      contractData,
      educationData,
      certificateData,
      workingData,
      familyData,
      TrainingData,
      appreciationData,
      violationData,
      retireData,
      attachmentData,
      assignmentData,
      getPhoto,
      fileData,
      image,
      modalContent,
      showActionColumn,
      isLoading,
      formatDate,
      employeeModal,
      editDataEmployee,
      refreshList,
      updateCarClosed,
      updateEmpDone,
      // salaryData
      resetModal,
      wordFile,
      downloadContractFile,
      triggerDownload,
      employeeHistoryModal,
      showEmployeeHistory,
      employeeHistoryData,
    };
  },
};
</script>

<style lang="scss">
.modal-employee-detail {
  width: 100%;
  height: calc(100dvh - 80px);
  overflow-y: auto;
  padding: 0 12px 12px 12px;

  .employee-detail-highlight {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 20px 0;

    .highlight-profile,
    .highlight-table {
      width: 100%;
      position: relative;
    }

    .highlight-profile {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px 16px;

      .profile-image {
        width: 160px;
        height: auto;
        overflow: hidden;
        aspect-ratio: 1 / 1;
        border-radius: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .profile-image-defult {
        aspect-ratio: 3 / 4;
        border-radius: 0;
      }

      .profile-name {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        padding-bottom: 20px;

        p {
          width: 100%;
          text-align: center;

          &:nth-child(1) {
            font-size: 20px;
            line-height: 28px;
            font-weight: 700;
          }

          &:nth-child(2),
          &:nth-child(3) {
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
          }
        }

        .pill-content {
          margin-top: 14px;
          border-radius: 20px;
        }
      }
    }

    .highlight-table {
      width: 100%;
      display: flex;
      align-items: center;

      table {
        width: 100%;

        tr {
          td {
            font-size: 14px;
            line-height: 24px;
            padding: 4px 0;
            vertical-align: top;

            &:nth-child(1) {
              width: 120px;
              color: gray;
            }

            &:nth-child(2) {
              width: 10px;
              color: gray;
            }

            &:nth-child(3) {
              width: calc(100% - 120px - 10px);
              font-weight: 600;
            }
          }

          &:hover {
            td {
              background-color: transparent !important;
            }
          }
        }
      }
    }

    @media (min-width: 600px) {
      .highlight-profile {
        flex-direction: row;
        padding-left: 20px;

        .profile-image {
          width: 140px;
        }

        .profile-name {
          align-items: start;
          padding-bottom: 0;

          p {
            text-align: left;

            &:nth-child(1) {
              font-size: 18px;
              line-height: 26px;
            }

            &:nth-child(2),
            &:nth-child(3) {
              font-size: 12px;
              line-height: 18px;
            }
          }
        }
      }
    }

    @media (min-width: 900px) {
      flex-direction: row;
      gap: 20px;

      .highlight-profile,
      .highlight-table {
        width: calc((100% - 20px) / 2);
      }

      .highlight-profile {
        &::before {
          content: "";
          width: 1px;
          height: 100%;
          position: absolute;
          top: 0;
          right: -9.5px;
          background-color: lightgray;
        }
      }
    }
  }

  .student-tab {
    .employe-tabs-container {
      width: 100%;
      position: sticky;
      top: 0;
      background-color: white;
      padding: 12px 0 0 0;

      .employe-tabs-outer {
        width: 100%;
        max-width: 100%;
        overflow-x: auto;
        padding-bottom: 12px;

        .employe-tabs-content {
          width: max-content;
          min-width: 100%;
          height: auto;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;

          .tab-content {
            background-color: rgb(236, 244, 255);
            padding: 8px 20px;
            cursor: pointer;
            transition: background-color 0.4s, color 0.4s;

            p {
              font-size: 14px;
              line-height: 20px;
              font-weight: 600;
            }
          }

          .tab-content-active {
            background-color: #152751;
            color: white;
          }
        }
      }

      @media (min-width: 600px) {
        padding: 12px 0;

        .employe-tabs-outer {
          padding-bottom: 0;
        }
      }
    }

    .employee-general-container {
      width: 100%;
      height: auto;
      min-height: calc(100dvh - 152px);

      .table-container {
        width: 100%;
        height: auto;

        .employee-buttons-action {
          width: 100%;
          height: auto;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          justify-content: end;
          align-items: end;
        }

        .table-content {
          width: 100%;
          max-width: 100%;
          height: auto;
          overflow-x: auto;
          margin-top: 12px;
          border: 1px solid rgb(233, 233, 233);

          table {
            min-width: 100%;
            width: max-content;
            border-collapse: collapse;

            thead {
              tr {
                th {
                  background-color: #152751;
                  color: white;
                  font-weight: 500;
                }
              }
            }

            tbody {
              tr {
                td {
                  background-color: white;

                  .table-buttons-action {
                    display: flex;
                    flex-direction: row;
                    gap: 8px;
                    justify-content: center;
                  }
                }

                &:nth-child(even) {
                  td {
                    background-color: whitesmoke;
                  }
                }
              }
            }

            tr {
              th,
              td {
                width: auto;
                min-width: max-content;
                max-width: 400px;
                padding: 8px 12px;
                font-size: 14px;
                line-height: 24px;
                outline: 1px solid rgb(233, 233, 233);
                outline-offset: -0.5px;

                &:nth-child(1) {
                  position: sticky;
                  left: 0;
                  text-align: center;
                }
              }

              td {
                padding: 4px 12px !important;
              }
            }
          }
        }

        .group-container {
          width: 100%;
          height: auto;
          border-top: 1px solid lightgray;
          margin-bottom: 20px;
          padding-top: 20px;

          &:nth-child(1) {
            border: none;
            padding-top: 0;
          }

          &:nth-last-child(1) {
            margin-bottom: 40px;
          }

          p.title-group {
            width: 100%;
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
            margin-bottom: 4px;
          }

          .group-content {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;

            table {
              width: 100%;

              tr {
                td {
                  vertical-align: top;
                  font-size: 14px;
                  line-height: 24px;
                  padding: 4px 0;

                  &:nth-child(1) {
                    width: 120px;
                    color: gray;
                  }

                  &:nth-child(2) {
                    width: 10px;
                    color: gray;
                  }

                  &:nth-child(3) {
                    width: calc(100% - 120px - 10px);
                    font-weight: 500;
                  }
                }

                &:hover {
                  td {
                    background-color: transparent;
                  }
                }
              }
            }

            @media (min-width: 600px) {
              table {
                tr {
                  td {
                    &:nth-child(1) {
                      width: 160px;
                    }

                    &:nth-child(3) {
                      width: calc(100% - 160px - 10px);
                    }
                  }
                }
              }
            }

            @media (min-width: 900px) {
              flex-direction: row;
              gap: 20px;

              table {
                width: calc((100% - 20px) / 2);
              }
            }
          }
        }
      }

      @media (min-width: 600px) {
        min-height: calc(100dvh - 180px);
      }
    }
  }
}

.student-tab {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;

  .tab-list {
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow-x: auto;
    /* // display: flex; */
    /* // justify-content: center; */
    margin-bottom: 28px;
    position: sticky;
    z-index: 15;
    top: 0;
    padding: 20px 0px 8px 0px;

    .tab-container {
      width: max-content;
      margin: 0 auto;

      .content-tab {
        width: max-content;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        p {
          width: 100%;
          font-size: 14px;
          line-height: 24px;
          color: gray;
          padding: 0 16px;
          margin-bottom: 8px;
          transition: color 0.5s, font-weight 0.5s;
        }

        .line-tab {
          width: 100%;
          height: 8px;
          background-color: rgb(214, 214, 214);
          transition: background-color 0.5s;
        }
      }

      .active-tab {
        p {
          font-weight: 600;
          color: rgb(2, 198, 2);
        }

        .line-tab {
          background-color: rgb(2, 198, 2);
        }
      }
    }
  }

  // .data-container {
  //   width: 100%;
  //   max-width: 100%;
  //   min-height: 70vh;
  //   height: auto;
  //   padding: 20px;
  //   position: relative;
  //   z-index: 13;
  //   /* // overflow-x: auto; */

  //   .data-content {
  //     width: 100%;
  //     max-width: 100%;
  //     min-height: max-content;
  //     height: auto;
  //     /* // padding-bottom: 160px; */
  //     overflow-x: auto;

  //     table {
  //       min-width: 100%;
  //       width: max-content;
  //       table-layout: fixed;
  //       overflow-wrap: break-word;
  //       word-wrap: break-word;

  //       thead {
  //         tr {
  //           th {
  //             font-size: 14px;
  //             line-height: 24px;
  //           }
  //         }
  //       }

  //       tbody {
  //         tr {
  //           td {
  //             font-size: 14px;
  //             line-height: 24px;
  //             letter-spacing: 0.6px;
  //             word-spacing: 2px;
  //             vertical-align: top;
  //             word-wrap: break-word !important;
  //             white-space: normal !important;
  //             word-break: break-all !important;
  //           }
  //         }
  //       }
  //     }
  //   }

  //   .single-table {
  //     /* table {
  //               // thead {
  //               //     tr {
  //               //         th {

  //               //         }
  //               //     }
  //               // } */

  //     tbody {
  //       tr {
  //         td {
  //           padding: 8px 12px;
  //           transition: background-color 0.3s;
  //           word-wrap: break-word !important;
  //           white-space: normal !important;
  //           word-break: break-all !important;

  //           &:nth-child(1) {
  //             width: 240px;
  //             border-right: 1px solid lightgray;

  //             @media (min-width: 768px) {
  //               position: sticky;
  //               left: 0;
  //             }
  //           }

  //           &:nth-child(2) {
  //             font-weight: 700;
  //           }
  //         }

  //         &:nth-child(even) {
  //           td {
  //             background-color: rgb(246, 246, 246);
  //           }
  //         }

  //         &:nth-child(odd) {
  //           td {
  //             background-color: white;
  //           }
  //         }

  //         &:hover {
  //           td {
  //             background-color: rgb(222, 239, 255);
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // .double-same-table {
  //   table {
  //     thead {
  //       tr {
  //         th {
  //           text-align: center;
  //         }
  //       }
  //     }

  //     tbody {
  //       tr {
  //         td {
  //           padding: 8px 12px;
  //           transition: background-color 0.3s;
  //           border-right: 1px solid lightgray;
  //           word-wrap: break-word !important;
  //           white-space: normal !important;
  //           word-break: break-all !important;

  //           &:nth-child(1) {
  //             width: 160px;
  //           }

  //           &:nth-child(2) {
  //             font-weight: 700;
  //           }

  //           &:nth-child(3) {
  //             font-weight: 700;
  //           }

  //           &:nth-last-child(1) {
  //             border-right: none;
  //           }
  //         }

  //         &:nth-child(even) {
  //           td {
  //             background-color: rgb(246, 246, 246);
  //           }
  //         }

  //         &:hover {
  //           td {
  //             background-color: rgb(222, 239, 255);
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
